export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/Illustration.cc3c6a5.svg";